<template>
  <v-card>
    <v-card-text>
      <h3>Illuminance</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Foot-candle (fc)',
          val: 1
        },
        {
          text: 'Kilolux (klx)',
          val: 0.01076391041671
        },
        {
          text: 'Lumen per square centimeter (lm/cm²)',
          val: 0.001076391041671
        },
        {
          text: 'Lumen per square meter (lm/m²)',
          val: 10.76391041671
        },
        {
          text: 'Lux (lx)',
          val: 10.76391041671
        },
        {
          text: 'Microlux (µlx)',
          val: 10763910.41671
        },
        {
          text: 'Millilux (mlx)',
          val: 10763.91041671
        },
        {
          text: 'Nox',
          val: 10763.91041671
        },
        {
          text: 'Phot (ph)',
          val: 0.001076391041671
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// illuminance.vue?d517d264